"use client";

import dynamic from "next/dynamic";

// Client-side async boundary for the date-of-birth check on /numerology/<1-9>/
// and /numerology/life-path/ (the #2460 pattern). The server pages import ONLY
// this module: a "use client" module imported by a server module ships in the
// route's first load even when unrendered, so the island, LIFE_PATHS and the
// digit arithmetic stay in one async chunk both routes share. Default ssr keeps
// the empty form in the server HTML, so a hard load hydrates in place.
//
// The reserve shows only during a client-side navigation. It matches the
// pre-result card plus its mt-6, measured in headless Chromium on the
// prerendered /numerology/life-path/ HTML (2026-10-05): 247px at 360-412px wide
// for both variants (min-h-62 = 248px), and 185px from 640px up to 1280px
// (min-h-46 = 184px). Only the life-path caption wraps once more, between 640px
// and about 670px (201px there) and below 360px (263px at 320px).
const NumerologyDobCheckLazy = dynamic(() => import("./NumerologyDobCheck"), {
  loading: () => <div aria-hidden="true" className="mt-6 min-h-62 sm:min-h-46" />,
});

export default NumerologyDobCheckLazy;
